import React from 'react'
import { Button, Result } from 'antd'
import { useSelector } from 'react-redux'
import { Link, useParams, Navigate, Outlet } from 'react-router-dom'

const CourseRoute = () => {
  const courses = useSelector((state) => state?.courses?.data)
  const { courseId } = useParams()

  const specificCourse = courses?.find((course) => course.id === courseId)

  if (!specificCourse?.enrolled) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={
          <Button type="primary">
            <Link to="/">Back Home</Link>
          </Button>
        }
      />
    )
  }

  return <Outlet />
}

export default CourseRoute
